import { DASH } from 'shared/constants';
import { FieldDataInformation } from 'shared/types';

export const createFieldFormatUnitFunction =
  (precision = 0) =>
  (data?: FieldDataInformation): string => {
    if (!data?.value) {
      return DASH;
    }

    if (typeof data.value === 'string') {
      return data.value;
    }

    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });

    return `${formatter.format(data.value)}`;
  };
